import { createPublicEventSeasonQuery } from "@api/solid-query/event-seasons";
import LoadingSpinner from "@components/LoadingSpinner";
import { createEffect, createSignal, Show } from "solid-js";

export const CurrentEventSeasonLeaderboard = () => {
  const eventSeasonQuery = createPublicEventSeasonQuery();
  const now = new Date();

  const currentLeaderboardData = () =>
    eventSeasonQuery.data?.find(
      (seasonData) =>
        new Date(seasonData.eventSeason.startTime) <= now &&
        now <= new Date(seasonData.eventSeason.endTime)
    );

  const [isLoading, setIsLoading] = createSignal(true);
  createEffect(() => {
    setIsLoading(eventSeasonQuery.isLoading);
  });

  const topTeams = () =>
    currentLeaderboardData()?.topTeams.filter((team) => team.score > 0);
  const jackpot = () =>
    Math.max(
      (currentLeaderboardData()?.eventSeason.currentJackpot || 0) +
        (currentLeaderboardData()?.eventSeason.currentJackpotOffset || 0),
      0
    );

  const prizes = () =>
    currentLeaderboardData()?.prizes?.map(
      (prize) => (parseInt(prize.percentage, 10) / 100.0) * jackpot() * 1.0
    );

  return (
    <Show when={!isLoading()} fallback={<LoadingSpinner />}>
      <Show when={currentLeaderboardData()}>
        <div class="md:px-10 px-4 w-full flex flex-col items-left md:items-center my-4">
          <div class="bg-white rounded-2xl shadow-2xl p-6 md:p-10 border border-green-200 w-full mx-auto md:px-6 px-4 my-8">
            <h1 class="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-green-800 to-green-700 text-center drop-shadow-md mb-4">
              {currentLeaderboardData()?.eventSeason.name}
            </h1>

            <h2 class="text-3xl md:text-4xl font-bold bg-clip-text bg-gradient-to-r from-green-800 to-green-700 text-center drop-shadow-sm mb-6">
              Current Jackpot: ${jackpot()?.toFixed(0)}
            </h2>

            <p class="text-lg md:text-xl font-medium text-center text-gray-700 leading-relaxed tracking-wide max-w-xl mx-auto px-4">
              <span class="italic">
                {currentLeaderboardData()?.eventSeason.description}
              </span>
            </p>
            <div class="w-full flex flex-col items-left md:items-center my-4">
              <table class="table table-zebra w-full shadow-xl rounded-xl overflow-hidden animate-fade-in">
                <thead class="bg-gradient-to-r from-green-800 to-green-600 text-white md:text-lg text-sm ">
                  <tr>
                    <th class="py-4">Name</th>
                    <th class="py-4">Events Played</th>
                    <th class="py-4 hidden md:table-cell">Avg. Rank</th>
                    <th class="py-4">Prize</th>
                  </tr>
                </thead>
                <tbody>
                  <Show
                    when={topTeams()?.length}
                    fallback={
                      <tr>
                        <td colSpan={6}>
                          <p class="my-4 text-2xl font-bold w-full text-center text-gray-500">
                            No Teams
                          </p>
                        </td>
                      </tr>
                    }
                  >
                    {topTeams()?.map((team, ind) => (
                      <tr class="hover:bg-purple-100 transition duration-200 ease-in-out">
                        <td class="font-semibold text-green-800 md:text-lg text-sm">
                          {team.name}
                        </td>
                        <td class="text-green-800 font-mono md:text-lg text-sm">
                          {team.numEvents}
                        </td>
                        <td class="text-green-800 font-mono hidden md:table-cell md:text-lg text-sm">
                          {team.averageRank}
                        </td>
                        <td class="text-green-800 font-mono md:text-lg text-sm">
                          {prizes()?.at(ind)?.toFixed(0)
                            ? `$${prizes()?.at(ind)?.toFixed(0)}`
                            : "-"}
                        </td>
                      </tr>
                    ))}
                  </Show>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Show>
    </Show>
  );
};
